export default "__VITE_ASSET__mrM_BQve__"